export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"referrer","content":"no-referrer-when-downgrade"},{"name":"format-detection","content":"telephone=no"},{"name":"msapplication-TileColor","content":"#00a300"},{"name":"theme-color","content":"#ffffff"},{"hid":"apple-itunes-app","name":"apple-itunes-app","content":"app-id=1188034434"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"apple-touch-icon","href":"/icon-48x48.png","sizes":"48x48"},{"rel":"apple-touch-icon","href":"/icon-72x72.png","sizes":"72x72"},{"rel":"apple-touch-icon","href":"/icon-96x96.png","sizes":"96x96"},{"rel":"apple-touch-icon","href":"/icon-144x144.png","sizes":"144x144"},{"rel":"apple-touch-icon","href":"/icon-192x192.png","sizes":"192x192"},{"rel":"apple-touch-icon","href":"/icon-256x256.png","sizes":"256x256"},{"rel":"apple-touch-icon","href":"/icon-512x512.png","sizes":"512x512"},{"rel":"preconnect","href":"https://campsites.camping.info","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://cdn.prod.v2.camping.info"},{"rel":"preconnect","href":"https://api.maptiler.com"},{"rel":"preconnect","href":"https://securepubads.g.doubleclick.net","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://cdn.h5v.eu/","crossorigin":"anonymous"},{"rel":"preconnect","href":"//sentry.io","crossorigin":""},{"rel":"dns-prefetch","href":"//sentry.io"},{"rel":"dns-prefetch","href":"https://campsites.camping.info"},{"rel":"dns-prefetch","href":"https://cdn.prod.v2.camping.info"},{"rel":"dns-prefetch","href":"https://api.maptiler.com"},{"rel":"preconnect","href":"b.delivery.consentmanager.net","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"b.delivery.consentmanager.net"},{"rel":"preconnect","href":"cdn.consentmanager.net","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"cdn.consentmanager.net"}],"style":[],"script":[{"innerHTML":"\n            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src=\"https://www.camping.info/sst/b3klbacezx.js?\"+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','ck4z10=aWQ9R1RNLUtUQ1BDVkg0&page=3');\n          "},{"hid":"consentmanager-config","innerHTML":"\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n  \n            if (!('cmp_cdid' in window)) {\n              window.cmp_cdid = 'bb9aeee691ea4';\n            }\n            if (!('cmp_host' in window)) {\n              window.cmp_host = 'b.delivery.consentmanager.net';\n            }\n            if (!('cmp_cdn' in window)) {\n              window.cmp_cdn = 'cdn.consentmanager.net';\n            }\n  \n            const splitPath = window.location.pathname.replace(/^\\//, '').split('/');\n            if (!splitPath.length) {\n              window.cmp_setlang = 'EN';\n            } else {\n              const lang = splitPath[0].toUpperCase();\n              if (lang === 'DE') {\n               window.cmp_setlang = lang;\n              } else {\n                window.cmp_setlang = 'EN';\n              }\n            }\n  \n            window.openCookieSettings = function() {\n              if (window && window.__cmp) {\n                window.__cmp(\"showScreenAdvanced\");\n              }\n            };\n          "}],"noscript":[],"htmlAttrs":{"lang":"de"},"charset":"utf-8","viewport":"width=device-width, initial-scale=1","bodyAttrs":{"class":"antialiased w-full text-black"},"titleTemplate":"%s - camping.info"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false